        window.Shopify.loadFeatures( [
            {
              name: 'consent-tracking-api',
              version: '0.1',
            },
          ],

          

          () => {

              // jeśli jesteś w edytorze motywu → całkowicie wyłącz zasłonkę
              if (window.Shopify.designMode) {
                document.querySelector('.private-shadow')?.classList.remove('active');
                return;
              }

              var shadow = document.querySelector('.private-shadow');

              if (window.Shopify.customerPrivacy.currentVisitorConsent().marketing != "no" && window.Shopify.customerPrivacy.currentVisitorConsent().marketing != "yes") {
                  shadow.classList.add('active');
              } else {
                  shadow.classList.remove('active');
              }

              document.body.addEventListener('click', e => {
                  if (e.target.closest('#pandectes-banner .cc-allow') ||
                      e.target.closest('#pandectes-banner .cc-deny') ||
                      e.target.closest('#pd-cp-preferences .pd-cp-btn.pd-cp-ui-save')
                      
                    // ||
                    //   e.target.closest('#pandectes-banner .cc-settings')
                    // ||
                    // e.target.closest('#shopify-pc__prefs__header-accept') ||
                    // e.target.closest('#shopify-pc__prefs__header-decline')
                    ) {
                  setTimeout(shadow.classList.remove('active'), 100);
                }
              });
            }
        );